export const INCOMINTG_SECTION = "isIncoming";
export const PRODUCTION_SECTION = "isProduction";
export const START_SECTION = "start";
export const END_SECTION = "end";
export const QUERY_SECTION = "query";
export const SPENDING_SECTION = "spendingId";
